import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  class: "expand-bar"
}
const _hoisted_3 = {
  key: 1,
  class: "title"
}

import { isExpand } from "@/views/Home/useData/useHomePage";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LeftHeader',
  setup(__props) {

const toolTips = computed(() => {
  return isExpand.value ? "收起侧边栏" : "打开侧边栏";
});

return (_ctx: any,_cache: any) => {
  const _component_Fold = _resolveComponent("Fold")!
  const _component_Expand = _resolveComponent("Expand")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isExpand))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "tag" }, "超时代AI", -1)),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: toolTips.value,
            placement: "right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, {
                size: 24,
                class: "expand-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (isExpand.value = !_unref(isExpand)))
              }, {
                default: _withCtx(() => [
                  (_unref(isExpand))
                    ? (_openBlock(), _createBlock(_component_Fold, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_Expand, { key: 1 }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["content"])
        ]))
      : _createCommentVNode("", true),
    (_unref(isExpand))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "deep R1满血版"))
      : _createCommentVNode("", true),
    (!_unref(isExpand))
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "compact-mode",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (isExpand.value = !_unref(isExpand)))
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("img", {
            src: _imports_0,
            class: "logo",
            alt: ""
          }, null, -1)),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: toolTips.value,
            placement: "right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, {
                size: 24,
                class: "expand-btn"
              }, {
                default: _withCtx(() => [
                  (_unref(isExpand))
                    ? (_openBlock(), _createBlock(_component_Fold, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_Expand, { key: 1 }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["content"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})